import { render, staticRenderFns } from "./TypeformModal.vue?vue&type=template&id=f943ad70&scoped=true&"
import script from "./TypeformModal.vue?vue&type=script&lang=ts&"
export * from "./TypeformModal.vue?vue&type=script&lang=ts&"
import style0 from "./TypeformModal.vue?vue&type=style&index=0&id=f943ad70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f943ad70",
  null
  
)

export default component.exports